import { createActionGroup, props } from '@ngrx/store';
import { id } from '@wonder-core-ng/interfaces/id.type';
import { IQueryEngineFilters } from './interfaces/query-engine.interface';

export const QueryEngineActions = createActionGroup({
  source: 'QueryEngine',
  events: {
    'Load Chart Data': props<{ query: IQueryEngineFilters }>(),
    'Load Chart Data Success': props<{ chartId: id; data: unknown; isComparative: boolean }>(),
    'Load Chart Data Failure': props<{ chartId: id; error: unknown }>(),

    'Unload Chart Data': props<{ chartId: id }>(),

    // httpResult
    'Http Result': props<{ action: string; error: unknown }>(),
  },
});
